import { ActionType } from '../constants/ActionTypes';
import config from '../constants/Configs';

import { RestPath } from '../constants/SitePaths';
import { Constants } from '../constants/Constants';
import axios from 'axios';
import NotificationService from '../components/base/notifications/NotificationService';
import { LanguageService } from '../services/LanguageService';

export const getCountriesBegin = () => ({
    type: ActionType.GET_COUNTRIES_BEGIN
});
export const getCountriesError = (data) => ({
    type: ActionType.GET_COUNTRIES_ERROR,
    payload: data
});
export const getCountriesSuccess = (data) => ({
    type: ActionType.GET_COUNTRIES_SUCCESS,
    payload: data
});

export const getCitiesBegin = () => ({
    type: ActionType.GET_CITIES_BEGIN
});
export const getCitiesError = (data) => ({
    type: ActionType.GET_CITIES_ERROR,
    payload: data
});
export const getCitiesSuccess = (data) => ({
    type: ActionType.GET_CITIES_SUCCESS,
    payload: data
});

export const getRegionsBegin = () => ({
    type: ActionType.GET_REGIONS_BEGIN
});
export const getRegionsError = (data) => ({
    type: ActionType.GET_REGIONS_ERROR,
    payload: data
});
export const getRegionsSuccess = (data) => ({
    type: ActionType.GET_REGIONS_SUCCESS,
    payload: data
});


export const updateLogo = (data) => ({
    type: ActionType.UPDATE_LOGO,
    payload: data
})

export const getRegistrationSettingsBegin = () => ({
    type: ActionType.GET_REGISTRATION_SETTINGS_BEGIN
});
export const getRegistrationSettingsError = (data) => ({
    type: ActionType.GET_REGISTRATION_SETTINGS_ERROR,
    payload: data
});
export const getRegistrationSettingsSuccess = (data) => ({
    type: ActionType.GET_REGISTRATION_SETTINGS_SUCCESS,
    payload: data
});


export const getLoginSettingsBegin = () => ({
    type: ActionType.GET_LOGIN_SETTINGS_BEGIN
});
export const getLoginSettingsError = (data) => ({
    type: ActionType.GET_LOGIN_SETTINGS_ERROR,
    payload: data
});
export const getLoginSettingsSuccess = (data) => ({
    type: ActionType.GET_LOGIN_SETTINGS_SUCCESS,
    payload: data
});

export const getProfileSettingsBegin = () => ({
    type: ActionType.GET_PROFILE_SETTINGS_BEGIN
});
export const getProfileSettingsError = (data) => ({
    type: ActionType.GET_PROFILE_SETTINGS_ERROR,
    payload: data
});
export const getProfileSettingsSuccess = (data) => ({
    type: ActionType.GET_PROFILE_SETTINGS_SUCCESS,
    payload: data
});

export const getNSEPBegin = () => ({
    type: ActionType.GET_NSEP_BEGIN
});
export const getNSEPError = (data) => ({
    type: ActionType.GET_NSEP_ERROR,
    payload: data
});
export const getNSEPSuccess = (data) => ({
    type: ActionType.GET_NSEP_SUCCESS,
    payload: data
});

export function getCountries() {
    return dispatch => {
        dispatch(getCountriesBegin());
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_COUNTRIES
        }).then((response) => {
            dispatch(getCountriesSuccess(response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getCountriesError(error.response.data));
                } else {
                    dispatch(getCountriesError(error));
                }

            });
    };
}

export function getCities(params) {
    return dispatch => {
        dispatch(getCitiesBegin());
        const l = LanguageService.getSelectedLanguage();
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_CITIES,
            params: {
                ...params,
                l
            }
        }).then((response) => {
            dispatch(getCitiesSuccess(response.data));
        }).catch((error) => {
            if (error.response) {
                dispatch(getCitiesError(error.response.data));
            } else {
                dispatch(getCitiesError(error));
            }

        });
    };
}
export function getRegions(countryId) {
    return dispatch => {
        dispatch(getRegionsBegin());
        const l = LanguageService.getSelectedLanguage();
        const params = { countryId, l };
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_REGIONS,
            params
        }).then((response) => {
            dispatch(getRegionsSuccess(response.data));
        }).catch((error) => {
            if (error.response) {
                dispatch(getRegionsError(error.response.data));
            } else {
                dispatch(getRegionsError(error));
            }

        });
    };
}


export function getRegistrationSettings() {
    return dispatch => {
        dispatch(getRegistrationSettingsBegin());
        const l = LanguageService.getSelectedLanguage();
        const params = { l };
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_REGISTRATION_SETTINGS,
            params
        }).then((response) => {
            dispatch(getRegistrationSettingsSuccess(response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getRegistrationSettingsError(error.response.data));
                } else {
                    dispatch(getRegistrationSettingsError(error));
                }
            });
    };
}



export function getLoginSettings() {
    return dispatch => {
        dispatch(getLoginSettingsBegin());
        const l = LanguageService.getSelectedLanguage();
        const params = { l };
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_LOGIN_SETTINGS,
            params
        }).then((response) => {
            dispatch(getLoginSettingsSuccess(response.data));
            return response.data
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getLoginSettingsError(error.response.data));
                } else {
                    dispatch(getLoginSettingsError(error));
                }
            });
    };
}

export function getProfileSettings() {
    return dispatch => {
        dispatch(getProfileSettingsBegin());
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_PROFILE_SETTINGS
        }).then((response) => {
            dispatch(getProfileSettingsSuccess(response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getProfileSettingsError(error.response.data));
                } else {
                    dispatch(getProfileSettingsError(error));
                }

            });
    };
}

export function getNSEP() {
    return dispatch => {
        dispatch(getNSEPBegin());
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_NSEP
        }).then((response) => {
            dispatch(getNSEPSuccess(response.data));
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getNSEPError(error.response.data));
                } else {
                    dispatch(getNSEPError(error));
                }

            });
    };
}

export function requestCallback(data) {
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.REQUEST_CALLBACK,
            data
        }).then(() => {
            return true
        }).catch(() => {
            NotificationService.error({ message: LanguageService.getTranslation('genericErrorMsg') });
        });

    };
}

export function requestChashback(data) {
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.REQUEST_CHASHBACK,
            data
        }).then((response) => {
            return response.data
        }).catch(() => {
            NotificationService.error({ message: LanguageService.getTranslation('genericErrorMsg') });
        });
    };
}

export function checkCashback(data) {
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: config.BASE_URL + RestPath.CHECK_CASHBACK,
            data
        }).then((response) => {
            return response.data
        }).catch(() => {
            NotificationService.error({ message: LanguageService.getTranslation('genericErrorMsg') });
        });

    };
}
